import { gql } from 'urql'

export const ACCOUNT_CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword {
    changePassword
  }
`
